<template>
  <div class="lm-loop-close">
    <div class="title">MoPaaS大模型 AI 加速闭环</div>
    <div class="box">
      <div class="content">基于MoPaaS 大模型 AI 平台以及大模型应用引擎，MoPaaS 打造大模型 AI 应用加速业务闭环，全方位提供大模型人才培训、项目教练、应用共建、技术平台等产品和服务方案，协助合作伙伴低成本和高效率地加速大模型应用落地。欢迎高校、企业、政府、团队和个人使用或参与MoPaaS 大模型 AI 加速闭环产品和服务，共创大模型 AI 应用生态！</div>
      <img src="../assets/images/lm-loop-close.png"/>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'ApplicationScope',
		data() {
      return {}
    }
	}
</script>

<style>

	@media (min-width:992px) {
    .lm-loop-close {
      background: #F5F6F9;
      padding: 120px 0;
    }

    .lm-loop-close .title {
      margin: 0 auto;
      height: 33px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #303133;
      line-height: 33px;
      text-align: center;
      font-style: normal;
    }

	.lm-loop-close .box {
		width: 1400px;
		margin: 40px auto 0;
	}

	.lm-loop-close .box .content {
      margin: 0 auto;
      height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #303133;
      line-height: 20px;
      text-align: center;
      font-style: normal;
    }
    .lm-loop-close .box img {
      width: 938px;
      height: 526px;
      margin: 40px auto;
    }
    .lm-loop-close .box .content2 {
      margin: 0 auto;
      height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #303133;
      line-height: 20px;
      text-align: center;
      font-style: normal;
    }
	}

	@media (max-width:992px) {
		.lm-loop-close .title {
			padding-top: 10px;
			margin-bottom: 15px;
		}

		.lm-loop-close .title h2 {
			font-size: 18px;
			line-height: 60px;
		}

		.lm-loop-close .title .vertical::before {
			content: '';
			display: block;
			position: absolute;
			top: 3px;
			left: -12px;
			width: 4px;
			height: 18px;
			background-color: #25A5FF;
		}

		.lm-loop-close .box {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			margin: 0 10px;
			padding: 0;
		}

		.lm-loop-close .box .item {
			margin: 0;
			padding: 0;
		}

		.lm-loop-close .box .item .up {
			height: 60px;
			padding: 3px 10px;
			margin-bottom: 3px;
			background-color: rgba(52, 156, 227, .1);
			align-items: center;
			border-radius: 4px;
		}

		.lm-loop-close .box .item .up img {
			height: 50px;
		}

		.lm-loop-close .box .item .up h4 {
			margin: 0 0 0 5px;
		}
		.lm-loop-close .box .item p {
			margin: 0 5px;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/LmLoopClose.vue